export default __webpack_public_path__ + "static/media/icon-Premia.54a2ca05.svg";